import { motion } from "framer-motion";

const sponsors = [
  "/images/invision.png",
  "/images/google.png",
  "/images/slack.png",
  "/images/microsoft.png",
  "/images/adobe.png",
  "/images/github.png",
  "/images/amazon.png",
];

const logoAnimation = {
  hidden: { opacity: 0, scale: 0.5 },
  show: {
    opacity: 1,
    scale: 1,
    transition: { type: "spring", stiffness: 300 }
  },
  hover: {
    scale: 1.1,
    transition: { duration: 0.3 }
  }
};

export default function SponsorsSection() {
  return (
    <motion.section
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-100px" }}
      className="px-4 py-12 bg-secondary"
    >
      <div className="max-w-7xl mx-auto text-center">
        <motion.h3
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-[clamp(1.75rem,1.536rem+1.071vw,2.5rem)] font-bold text-primary mb-10"
        >
          Our Champions Behind the Scenes
        </motion.h3>

        <section
          className="py-12 px-6 max-w-6xl mx-auto rounded-lg overflow-hidden relative"
          data-aos="fade-up"
         
        >
          <div className="">
            <div className="flex gap-6 sm:gap-8 md:gap-10 w-max items-center animate-marquee">
              {[...sponsors, ...sponsors].map((logo, index) => (
                <motion.div
                  key={index}
                  variants={logoAnimation}
                  initial="hidden"
                  whileInView="show"
                  whileHover="hover"
                  viewport={{ once: true }}
                  className="min-w-[100px] sm:min-w-[120px] md:min-w-[140px] flex justify-center items-center"
                >
                  <img
                    src={logo}
                    alt={`Sponsor ${index}`}
                    className="h-12 w-auto object-contain"
                  />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </motion.section>
  );
}
